export default function ShoppingBagBoldIcon() {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M16 8.75C15.59 8.75 15.25 8.41 15.25 8V4.5C15.25 3.42 14.58 2.75 13.5 2.75H10.5C9.42 2.75 8.75 3.42 8.75 4.5V8C8.75 8.41 8.41 8.75 8 8.75C7.59 8.75 7.25 8.41 7.25 8V4.5C7.25 2.59 8.59 1.25 10.5 1.25H13.5C15.41 1.25 16.75 2.59 16.75 4.5V8C16.75 8.41 16.41 8.75 16 8.75Z"
          className="svg-fill"
        />
        <path
          d="M7.99984 17.78C7.58984 17.78 7.24984 17.44 7.24984 17.03C7.24984 16.61 7.58984 16.28 7.99984 16.28H19.7598C20.0598 16.28 20.2898 16.02 20.2598 15.72L19.5798 10.03C19.3398 8.09 18.9998 6.5 15.5998 6.5H8.39984C4.99984 6.5 4.65984 8.09 4.42984 10.03L3.52984 17.53C3.23984 19.99 3.99984 22 7.50984 22H16.4898C19.6498 22 20.5798 20.37 20.5298 18.25C20.5198 17.98 20.2998 17.78 20.0298 17.78H7.99984Z"
          className="svg-fill"
        />
      </svg>
    </>
  );
}
